import type { ContextProviderProps } from './types';

import { createContext } from 'react';

export const PageLoaderContext = createContext<ContextProviderProps>({
  isPageLoading: false,
  setIsPageLoading: () => {},
});
